import { Component, EventEmitter, Output, computed, inject } from '@angular/core';
import { StatusComponent } from '../../../../../components/ui/status/status.component';
import { SmartBroadcastService } from '../../../../../services/smart-broadcast/smart-broadcast.service';
import { formatCount } from '../../../../../../utils/sms';

/**
 * The broadcast so far, filling in as each step is done: the sheet, who
 * gets a message, the sender, the name and what it costs in SMS parts.
 */
@Component({
  selector: 'sb-summary',
  standalone: true,
  imports: [StatusComponent],
  templateUrl: './summary.component.html',
  styleUrls: ['../../sb-shared.css', './summary.component.css'],
})
export class SummaryComponent {
  /** Asks the page to go back to a step. */
  @Output() edit = new EventEmitter<number>();

  store = inject(SmartBroadcastService);
  readonly formatCount = formatCount;

  readonly stats = computed(() => this.store.numberStats());
  readonly totals = computed(() => this.store.totals());

  readonly perMessage = computed(() => {
    const { parts, messages } = this.totals();
    if (!messages) return '';
    const average = parts / messages;
    return average === 1 ? '1 per message' : `${average.toFixed(1).replace(/\.0$/, '')} per message on average`;
  });

  /** Steps can be revisited until the broadcast is sent. */
  canEdit(step: number): boolean {
    return !this.store.sent() && !this.store.loading() && step <= this.store.reachable() && step !== this.store.step();
  }

  plural(count: number, one: string, many: string): string {
    return count === 1 ? one : many;
  }
}
